import { render, staticRenderFns } from "./templateDetailsModal.vue?vue&type=template&id=075524a9&"
import script from "./templateDetailsModal.vue?vue&type=script&lang=js&"
export * from "./templateDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports